import{a as A,b as E}from"./ids-chunk-HPURO4XG.js";import{a as v}from"./ids-chunk-U4K5B3VN.js";import{a as f,b as y}from"./ids-chunk-XE4WFW5M.js";import{a as b}from"./ids-chunk-W3LDHTW6.js";import{e as s}from"./ids-chunk-Y6KVKFJX.js";import{a as i}from"./ids-chunk-TFRXZ5TN.js";import{a as m,c as a,d as c,e as h,f as n}from"./ids-chunk-ZMMCFAAI.js";var I=`@charset "UTF-8";
/* Ids Loading Indicator */
:host(ids-loading-indicator:not([linear]):not([sticky])) {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

:host(ids-loading-indicator:not([linear]):not([sticky]):not([inline])) {
  width: 50px;
  height: 50px;
}

:host(ids-loading-indicator[inline]:not([linear]):not([sticky])) {
  width: 11px;
  height: 11px;
}

:host(ids-loading-indicator[align=center]:not([linear]):not([sticky]):not([inline])) {
  position: fixed;
  inset-block-start: 50%;
  inset-inline-start: 50%;
  margin-block-start: -25px;
}

:host(ids-loading-indicator[align=center][contained]:not([sticky]):not([inline])) {
  position: absolute;
  margin: 0;
  inset-block-start: 0;
  inset-inline-start: 0;
  height: 100%;
  width: 100%;
}

:host(ids-loading-indicator[stopped]:not([linear]):not([sticky]):not([inline])) {
  display: none;
}

:host(ids-loading-indicator[linear]),
:host(ids-loading-indicator[sticky]) {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
}

:host(ids-loading-indicator[sticky]) {
  position: absolute;
  align-items: center;
  top: 0;
  left: 0;
}

:host(ids-loading-indicator[linear]) {
  align-items: flex-end;
  height: 48px;
}

:host(ids-loading-indicator[overlay]) {
  z-index: var(--ids-z-index-top-level-container);
}

.progress {
  transition: stroke-dashoffset 0.275s ease-in, transform 0.275s ease-in;
  z-index: 1;
}

.progress-percentage {
  display: flex;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 49%;
  transform: translate(-50%, -50%);
  color: var(--ids-loading-indicator-color-text);
}

.progress-percentage.linear {
  top: 50%;
}

.percentage {
  position: relative;
  top: -4px;
  right: -2px;
}

svg.linear-indicator {
  display: flex;
  align-items: center;
  width: 100%;
  height: var(--ids-loading-indicator-height);
  overflow: hidden;
}
svg.linear-indicator.sticky {
  height: var(--ids-loading-indicator-height);
}
svg.linear-indicator .progress {
  fill: var(--ids-loading-indicator-progress-color);
  transform: scaleX(calc(var(--progress) * 1%));
}
svg.linear-indicator .circle {
  fill: var(--ids-loading-indicator-circle-color);
}

svg.circular-indicator {
  position: relative;
  overflow: visible;
  fill: var(--ids-color-transparent);
  transform-origin: 50% 50%;
  transform: rotateZ(-90deg);
  display: flex;
  align-items: center;
  justify-content: center;
}
svg.circular-indicator circle {
  transform-origin: 50% 50%;
}
svg.circular-indicator .circle {
  stroke: var(--ids-loading-indicator-circle-color);
}
svg.circular-indicator .progress {
  stroke-dasharray: 283;
  stroke: var(--ids-loading-indicator-progress-color);
}

svg.circular-indicator:not(.inline) {
  width: 50px;
  height: 50px;
}

svg.circular-indicator.inline {
  width: 11px;
  height: 11px;
}

.circular-indicator.determinate .progress {
  /*
   * circumference is 2\u03C0r(45) => 282.74, or 283
   */
  stroke-dashoffset: calc(283px - (var(--progress) * 2.83));
}

.ai-loading-indicator {
  display: flex;
  position: relative;
  width: 56px;
}

.ai-loading-indicator .bar {
  margin-right: 2px;
  margin-left: 2px;
  background-color: #F98300;
  width: 16px;
  height: 8px;
  border-radius: 8px;
  transition: 0.2s;
  animation: loading 1.2s ease-in-out 0.2s infinite;
}

.ai-loading-indicator .bar:nth-child(1) {
  background-color: #254A92;
  animation-delay: 0s;
}

.ai-loading-indicator .bar:nth-child(2) {
  background-color: #10B6A6;
  animation-delay: 0.14s;
}

.ai-loading-indicator .bar:nth-child(3) {
  background-color: #CBEFDC;
  animation-delay: 0.42s;
}

@keyframes indeterminate-spinner-progress-anim {
  0%, 15% {
    stroke-dashoffset: 272;
    transform: rotate(0);
  }
  60% {
    stroke-dashoffset: 80;
    transform: rotate(45deg);
  }
  65% {
    stroke-dashoffset: 80;
    transform: rotate(45deg);
  }
  100% {
    stroke-dashoffset: 272;
    transform: rotate(360deg);
  }
}
@keyframes indeterminate-spinner-anim {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
svg.circular-indicator.indeterminate .progress {
  animation: 1.52s linear infinite both indeterminate-spinner-progress-anim;
}

svg.circular-indicator.indeterminate {
  animation: 2.4s linear infinite indeterminate-spinner-anim;
}

svg.linear-indicator.indeterminate .progress {
  animation: 2.8s linear infinite both indeterminate-linear-progress-anim;
}

@keyframes indeterminate-linear-progress-anim {
  0% {
    transform: scaleX(0%) translateX(0%);
  }
  3.125%, 53.125% {
    transform: scaleX(20%) translateX(0%);
  }
  6.25% {
    transform: scaleX(30%) translateX(20%);
  }
  12.5%, 62.5% {
    transform: scaleX(45%) translateX(60%);
  }
  25%, 75% {
    transform: scaleX(100%) translateX(100%);
  }
  25.0000001%, 50%, 75.0000001%, 100% {
    transform: scaleX(0%) translateX(0);
  }
}
@keyframes loading {
  0% {
    height: 8px;
  }
  50% {
    width: 56px;
  }
  100% {
    height: 8px;
  }
}
:host([size=xs]:not([linear]):not([sticky]):not([inline])), :host([size=xs]:not([linear]):not([sticky]):not([inline]))::part(container) {
  width: 15px;
  height: 15px;
}
:host([size=xs]:not([linear]):not([sticky]):not([inline]))::part(circle) {
  stroke-width: 12;
}
:host([size=xs]:not([linear]):not([sticky]):not([inline]))::part(progress) {
  stroke-width: 21;
}

:host(.type-primary)::part(circle) {
  stroke: var(--ids-loading-indicator-primary-circle-stroke);
}
:host(.type-primary)::part(progress) {
  stroke: var(--ids-loading-indicator-primary-progress-color-border);
}

:host(.type-primary-destructive)::part(progress) {
  stroke: var(--ids-loading-indicator-primary-destructive-progress-color-border);
}
:host(.type-primary-destructive)::part(circle) {
  stroke: var(--ids-loading-indicator-primary-destructive-circle-stroke);
}

:host(.type-tertiary-destructive)::part(progress) {
  stroke: var(--ids-loading-indicator-destructive-progress-color-border);
}
:host(.type-tertiary-destructive)::part(circle) {
  stroke: var(--ids-loading-indicator-tertiary-destructive-circle-stroke);
}`;var x=v(b),r,g,p,k,o,d,l=class extends x{constructor(){super();c(this,r);c(this,o)}connectedCallback(){super.connectedCallback(),n(this,r,g).call(this)}static get attributes(){return[i.ALIGN,i.CONTAINED,i.GENERATIVE_AI,i.INLINE,i.LINEAR,i.OVERLAY,i.PERCENTAGE_VISIBLE,i.PROGRESS,i.STICKY,i.TYPE,i.VISIBLE]}template(){let t="circular";return this.hasAttribute(i.STICKY)&&(t="sticky"),this.hasAttribute(i.LINEAR)&&(t="linear"),this.hasAttribute(i.GENERATIVE_AI)&&(t="generative-ai"),this.hasAttribute(i.CONTAINED)&&(t="contained"),E({progress:this.progress,percentageVisible:this.percentageVisible,inline:this.inline,type:t,slotted:this.classList.contains("slot-loading-indicator")})}get inline(){return this.hasAttribute(i.INLINE)}set inline(t){let e=s(t);e&&this.setAttribute(i.INLINE,""),e||this.removeAttribute(i.INLINE)}get progress(){let t=this.getAttribute(i.PROGRESS);return t!==null?parseInt(t):void 0}set progress(t){!Number.isNaN(Number.parseFloat(t))?(this.setAttribute(i.PROGRESS,String(parseFloat(t))),this.shadowRoot?.querySelector("svg")?.classList.remove("indeterminate"),this.shadowRoot?.querySelector("svg")?.classList.add("determinate")):this.removeAttribute(i.PROGRESS),n(this,r,g).call(this)}set sticky(t){n(this,r,d).call(this,i.STICKY,s(t))}get sticky(){return this.hasAttribute(i.STICKY)}set contained(t){n(this,r,d).call(this,i.CONTAINED,s(t))}get contained(){return this.hasAttribute(i.CONTAINED)}set percentageVisible(t){let e=s(t);e&&!this.hasAttribute(i.PERCENTAGE_VISIBLE)?this.setAttribute(i.PERCENTAGE_VISIBLE,""):!e&&this.hasAttribute(i.PERCENTAGE_VISIBLE)&&this.removeAttribute(i.PERCENTAGE_VISIBLE),n(this,r,p).call(this)}get percentageVisible(){return this.hasAttribute(i.PERCENTAGE_VISIBLE)}get overlay(){return s(this.getAttribute(i.OVERLAY))}set overlay(t){let e=s(t);e?this.setAttribute(i.OVERLAY,""):this.removeAttribute(i.OVERLAY),n(this,r,k).call(this,e)}stop(){this.setAttribute("stopped","")}start(){this.removeAttribute("stopped")}set linear(t){n(this,r,d).call(this,i.LINEAR,s(t))}get linear(){return this.hasAttribute(i.LINEAR)}set generativeAi(t){s(t)?(this.shadowRoot?.querySelector(".ai-loading-indicator")?.remove(),this.setAttribute(i.GENERATIVE_AI,""),this.render(!0),this.shadowRoot?.querySelectorAll(".ai-loading-indicator")?.length===2&&this.shadowRoot?.querySelector(".ai-loading-indicator")?.remove()):(this.shadowRoot?.querySelector(".ai-loading-indicator")?.remove(),this.removeAttribute(i.GENERATIVE_AI),this.render(!0))}get generativeAi(){return s(this.getAttribute(i.GENERATIVE_AI))}set align(t){t==="center"?this.setAttribute(i.ALIGN,"center"):this.removeAttribute(i.ALIGN)}get align(){return this.getAttribute(i.ALIGN)||"normal"}get type(){return a(this,o)||"circular"}};r=new WeakSet,g=function(){this.progress!==void 0&&!Number.isNaN(this.progress)?this.shadowRoot?.querySelector("svg")?.style.setProperty("--progress",this.type==="circular"?`${this.progress}px`:this.progress):this.shadowRoot?.querySelector("svg")?.style.removeProperty("--progress"),n(this,r,p).call(this)},p=function(){let t=this.shadowRoot?.querySelector('[part="percentage-text"]');if(t&&t.remove(),this.percentageVisible&&this.type!=="sticky"){let e=document.createElement("template");e.innerHTML=A({type:this.type,progress:this.progress}),this.shadowRoot?.appendChild(e.content.cloneNode(!0))}},k=function(t){let e=this.shadowRoot?.querySelector("ids-overlay");t?e?.setAttribute("visible","true"):e?.removeAttribute("visible")},o=new WeakMap,d=function(t,e){let u=s(e);u&&(a(this,o)!==t&&(a(this,o)&&this.hasAttribute(a(this,o))&&this.removeAttribute(a(this,o)),h(this,o,t),this.hasAttribute(t)||this.setAttribute(t,""),this.render(!0)),this.hasAttribute(t)||this.setAttribute(t,"")),u||(this.hasAttribute(t)&&this.removeAttribute(t),a(this,o)===t&&(h(this,o,void 0),this.render(!0)))},l=m([f("ids-loading-indicator"),y(I)],l);export{l as a};
